import React, { Fragment, useContext } from 'react';
import {observer} from 'mobx-react-lite/dist/index';
import {StoreContext} from '../../helpers/StoreContext'


export default observer( () => {
  const styleStore = useContext(StoreContext).styleStore;

  const html = styleStore.footerHtml;

  if ((html)) {
    return (
      <Fragment>
        <div dangerouslySetInnerHTML={{__html: html}} />
      </Fragment>
    );
  }

  return '';

});
